import { tx } from '@transifex/native'
import axios from 'axios'
import dayjs from 'dayjs'
import moment from 'moment'

tx.init({ token: '1/1b8e42d357f8d0ab8c862ecb20eebe1738f569a6' })

// eslint-disable-next-line import/prefer-default-export
export const changeLanguage = (lng) => {
  localStorage.language = lng
  axios.defaults.headers.common['x-locale'] = lng
  tx.setCurrentLocale(lng)

  dayjs.locale(lng)
  moment.locale(lng)
}
